import moment from 'moment'
import React from 'react'
import * as S from './styles'
import 'moment/locale/pt-br'

export function AmbulatoryScheduleReScheduleHistory() {
  return (
    <>
      <S.ReScheduleItem>
        <S.ReScheduleDot />
        <label>
          Agendamento alterado para dia,{' '}
          <strong>
            {moment(new Date())
              .locale('pt-br')
              .format('DD [de] MMMM, dddd HH:MM')}
          </strong>{' '}
          pelo paciente via chatbot
        </label>
        <label>1h</label>
      </S.ReScheduleItem>
      <hr />
    </>
  )
}
